// ============================================================================
// CONSTANTS & ENUMS
// ============================================================================

export const PROJECTILE = 0;
export const STATIC_PROJECTILE = 1;
export const MODIFIER = 2;
export const DRAW_MANY = 3;
export const MATERIAL = 4;
export const OTHER = 5;
export const UTILITY = 6;
export const PASSIVE = 7;

class Spell {
    constructor(name, type, spawn_probabilities) {
        this.name = name;
        this.type = type;
        this.spawn_probabilities = spawn_probabilities;
    }
}

// ============================================================================
// SPELL DATA
// ============================================================================

export const ALL_SPELLS = [
  new Spell("BOMB", PROJECTILE, [1, 1, 1, 1, 0.5, 0.5, 0.1, 0, 0, 0, 0]),
  new Spell("LIGHT_BULLET", PROJECTILE, [2, 1, 0.5, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("LIGHT_BULLET_TRIGGER", PROJECTILE, [1, 0.5, 0.5, 0.5, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("LIGHT_BULLET_TRIGGER_2", PROJECTILE, [0, 0, 1, 0.5, 0, 1, 1, 0, 0, 0, 0.2]),
  new Spell("LIGHT_BULLET_TIMER", PROJECTILE, [0, 0.5, 0.5, 0.75, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("BULLET", PROJECTILE, [0, 1, 1, 1, 0.8, 0.5, 0, 0, 0, 0, 0]),
  new Spell("BULLET_TRIGGER", PROJECTILE, [0, 0.5, 0.5, 0.5, 0.6, 0.5, 0, 0, 0, 0, 0]),
  new Spell("BULLET_TIMER", PROJECTILE, [0, 0, 0.5, 0.5, 0.5, 0.5, 0.6, 0, 0, 0, 0]),
  new Spell("HEAVY_BULLET", PROJECTILE, [0, 0.5, 1, 1, 1, 1, 1, 0, 0, 0, 0]),
  new Spell("HEAVY_BULLET_TRIGGER", PROJECTILE, [0, 0, 0.5, 0.5, 0.5, 0.7, 0.5, 0, 0, 0, 0]),
  new Spell("HEAVY_BULLET_TIMER", PROJECTILE, [0, 0, 0.5, 0.5, 0.5, 0.5, 0.7, 0, 0, 0, 0]),
  new Spell("AIR_BULLET", PROJECTILE, [0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("SLOW_BULLET", PROJECTILE, [0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0]),
  new Spell("SLOW_BULLET_TRIGGER", PROJECTILE, [0, 0.5, 0.5, 0.5, 0.5, 1, 0, 0, 0, 0, 0]),
  new Spell("SLOW_BULLET_TIMER", PROJECTILE, [0, 0.5, 0.5, 0.5, 0.5, 1, 1, 0, 0, 0, 0]),
  new Spell("HOOK", PROJECTILE, [0, 0.1, 0.3, 0.4, 0.2, 0.1, 0, 0, 0, 0, 0]),
  new Spell("BLACK_HOLE", PROJECTILE, [0.8, 0, 0.8, 0, 0.8, 0.8, 0, 0, 0, 0, 0]),
  new Spell("BLACK_HOLE_DEATH_TRIGGER", PROJECTILE, [0, 0, 0.5, 0, 0.5, 0.5, 0.5, 0, 0, 0, 0]),
  new Spell("WHITE_HOLE", PROJECTILE, [0.05, 0, 0.05, 0, 0.1, 0, 0.2, 0, 0, 0, 0.5]),
  new Spell("BLACK_HOLE_BIG", STATIC_PROJECTILE, [0, 0.8, 0, 0.8, 0, 0.8, 0.8, 0, 0, 0, 0.5]),
  new Spell("WHITE_HOLE_BIG", STATIC_PROJECTILE, [0, 0.05, 0, 0.05, 0, 0.1, 0.4, 0, 0, 0, 0.2]),
  new Spell("BLACK_HOLE_GIGA", STATIC_PROJECTILE, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("WHITE_HOLE_GIGA", STATIC_PROJECTILE, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("TENTACLE_PORTAL", PROJECTILE, [0, 0.4, 0.4, 0.4, 0.5, 0, 0, 0, 0, 0, 0.2]),
  new Spell("SPITTER", PROJECTILE, [1, 1, 1, 0.5, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("SPITTER_TIMER", PROJECTILE, [0.5, 0.5, 0.5, 1, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("SPITTER_TIER_2", PROJECTILE, [0, 0, 1, 1, 1, 0.5, 0, 0, 0, 0, 0]),
  new Spell("SPITTER_TIER_2_TIMER", PROJECTILE, [0, 0, 0.5, 0.5, 0.5, 1, 0, 0, 0, 0, 0]),
  new Spell("SPITTER_TIER_3", PROJECTILE, [0, 0, 0, 0.8, 0.8, 1, 1, 0, 0, 0, 0]),
  new Spell("SPITTER_TIER_3_TIMER", PROJECTILE, [0, 0, 0, 0, 0.5, 0.65, 0.5, 0, 0, 0, 0]),
  new Spell("BUBBLESHOT", PROJECTILE, [1, 0.6, 1, 0.5, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("BUBBLESHOT_TRIGGER", PROJECTILE, [0, 0.5, 0.5, 1, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("DISC_BULLET", PROJECTILE, [1, 0, 1, 0, 0.6, 0, 0, 0, 0, 0, 0]),
  new Spell("DISC_BULLET_BIG", PROJECTILE, [0.6, 0, 0.7, 0, 0.8, 0, 0, 0, 0, 0, 0]),
  new Spell("DISC_BULLET_BIGGER", PROJECTILE, [0, 0, 0.1, 0.6, 0, 1, 0, 0, 0, 0, 0.4]),
  new Spell("BOUNCY_ORB", PROJECTILE, [1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0]),
  new Spell("BOUNCY_ORB_TIMER", PROJECTILE, [0.5, 0, 0.5, 0, 0.5, 0, 0, 0, 0, 0, 0]),
  new Spell("RUBBER_BALL", PROJECTILE, [1, 1, 0, 0, 0, 0, 0.2, 0, 0, 0, 0]),
  new Spell("ARROW", PROJECTILE, [0, 1, 1, 0, 0.6, 0.3, 0, 0, 0, 0, 0]),
  new Spell("POLLEN", PROJECTILE, [0.6, 1, 0, 1, 0.6, 0, 0, 0, 0, 0, 0]),
  new Spell("LANCE", PROJECTILE, [0, 0.9, 1, 0, 0, 0.8, 1, 0, 0, 0, 0]),
  new Spell("LANCE_HOLY", PROJECTILE, [0, 0, 0, 0.5, 0, 0.8, 1, 0, 0, 0, 0]),
  new Spell("ROCKET", PROJECTILE, [0, 1, 1, 1, 0.5, 0.3, 0, 0, 0, 0, 0]),
  new Spell("ROCKET_TIER_2", PROJECTILE, [0, 0, 0.5, 1, 1, 0.8, 0.5, 0, 0, 0, 0]),
  new Spell("ROCKET_TIER_3", PROJECTILE, [0, 0, 0.25, 0.5, 1, 1, 1, 0, 0, 0, 0]),
  new Spell("GRENADE", PROJECTILE, [1, 1, 0.5, 0.25, 0.2, 0, 0, 0, 0, 0, 0]),
  new Spell("GRENADE_TRIGGER", PROJECTILE, [0.5, 0.5, 0.2, 0.5, 0.5, 1, 0, 0, 0, 0, 0]),
  new Spell("GRENADE_TIER_2", PROJECTILE, [0, 0.5, 1, 1, 1, 0.5, 0, 0, 0, 0, 0]),
  new Spell("GRENADE_TIER_3", PROJECTILE, [0, 0.25, 0.5, 0.75, 1, 1, 0, 0, 0, 0, 0]),
  new Spell("GRENADE_ANTI", PROJECTILE, [0.4, 0.4, 0.7, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("GRENADE_LARGE", PROJECTILE, [0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("MINE", PROJECTILE, [0, 1, 0, 0.75, 1, 0, 0.5, 0, 0, 0, 0]),
  new Spell("MINE_DEATH_TRIGGER", PROJECTILE, [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0]),
  new Spell("PIPE_BOMB", PROJECTILE, [0, 0, 1, 1, 0.6, 0, 0, 0, 0, 0, 0]),
  new Spell("PIPE_BOMB_DEATH_TRIGGER", PROJECTILE, [0, 0, 0.6, 0.8, 1, 0.8, 0, 0, 0, 0, 0]),
  new Spell("FISH", PROJECTILE, [0, 0, 0, 0.01, 0.01, 0.01, 0, 0, 0, 0, 0]),
  new Spell("EXPLODING_DEER", PROJECTILE, [0, 0, 0, 0.6, 0.6, 0.6, 0, 0, 0, 0, 0]),
  new Spell("EXPLODING_DUCKS", PROJECTILE, [0, 0, 0, 0.8, 0.5, 0.6, 0, 0, 0, 0, 0]),
  new Spell("WORM_SHOT", PROJECTILE, [0, 0, 0, 0.6, 0.8, 0.6, 0.4, 0, 0, 0, 0.6]),
  new Spell("BOMB_DETONATOR", STATIC_PROJECTILE, [0, 0, 0.5, 1, 0.4, 0.5, 1, 0, 0, 0, 0]),
  new Spell("LASER", PROJECTILE, [0, 1, 1, 0, 1, 0, 0, 0, 0, 0, 0]),
  new Spell("MEGALASER", PROJECTILE, [0, 0, 0, 0.6, 0.6, 0.8, 0.6, 0, 0, 0, 0.3]),
  new Spell("LIGHTNING", PROJECTILE, [0, 1, 0.9, 0, 0, 0.7, 1, 0, 0, 0, 0]),
  new Spell("BALL_LIGHTNING", PROJECTILE, [0, 0.2, 0.4, 0, 1, 1, 0, 0, 0, 0, 0]),
  new Spell("LASER_EMITTER", PROJECTILE, [0, 0.2, 0.8, 1, 0.5, 0, 0, 0, 0, 0, 0]),
  new Spell("LASER_EMITTER_FOUR", PROJECTILE, [0, 0.2, 0.9, 0.3, 0.5, 1, 0, 0, 0, 0, 0]),
  new Spell("LASER_EMITTER_CUTTER", PROJECTILE, [0.2, 0.3, 1, 0.5, 0.1, 0, 0, 0, 0, 0, 0]),
  new Spell("DIGGER", PROJECTILE, [0, 1, 0.5, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("POWERDIGGER", PROJECTILE, [0, 0, 0.5, 1, 0.8, 0, 0, 0, 0, 0, 0]),
  new Spell("CHAINSAW", PROJECTILE, [1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("LUMINOUS_DRILL", PROJECTILE, [1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0.1]),
  new Spell("LASER_LUMINOUS_DRILL", PROJECTILE, [1, 0, 1, 0, 0, 0, 0.2, 0, 0, 0, 0.1]),
  new Spell("TENTACLE", PROJECTILE, [0, 0, 0, 1, 0.5, 1, 0.8, 0, 0, 0, 0]),
  new Spell("TENTACLE_TIMER", PROJECTILE, [0, 0, 0, 0.6, 0.8, 0.6, 0.7, 0, 0, 0, 0]),
  new Spell("HEAL_BULLET", PROJECTILE, [0, 0, 1, 1, 0.6, 0, 0, 0, 0, 0, 0]),
  new Spell("ANTIHEAL", PROJECTILE, [0, 0, 0.4, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0]),
  new Spell("SPIRAL_SHOT", PROJECTILE, [0, 0, 0, 0, 0.7, 0.8, 0.7, 0, 0, 0, 0]),
  new Spell("MAGIC_SHIELD", PROJECTILE, [0, 0, 0.5, 0, 0.6, 0.7, 1, 0, 0, 0, 0]),
  new Spell("BIG_MAGIC_SHIELD", PROJECTILE, [0, 0, 0.2, 0, 0.4, 0.5, 0.6, 0, 0, 0, 0.2]),
  new Spell("CHAIN_BOLT", PROJECTILE, [0.75, 0, 0, 0, 1, 0.8, 0.6, 0, 0, 0, 0]),
  new Spell("FIREBALL", PROJECTILE, [1, 0, 0, 0.7, 1, 0, 0.5, 0, 0, 0, 0]),
  new Spell("METEOR", PROJECTILE, [0, 0, 0, 0, 0.6, 0.6, 0.7, 0, 0, 0, 0.5]),
  new Spell("FLAMETHROWER", PROJECTILE, [0, 0, 0.8, 0.9, 0.9, 0, 0.6, 0, 0, 0, 0]),
  new Spell("ICEBALL", PROJECTILE, [0, 0, 0.8, 0.9, 0.9, 0, 0.6, 0, 0, 0, 0]),
  new Spell("SLIMEBALL", PROJECTILE, [1, 0, 0, 1, 0.7, 0, 0, 0, 0, 0, 0]),
  new Spell("DARKFLAME", PROJECTILE, [0, 0, 0, 1, 0, 0.9, 0.8, 0, 0, 0, 0]),
  new Spell("MISSILE", PROJECTILE, [0, 0.5, 0.5, 1, 0, 1, 0, 0, 0, 0, 0]),
  new Spell("FUNKY_SPELL", PROJECTILE, [0, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0.1]),
  new Spell("PEBBLE", PROJECTILE, [0, 0.9, 1, 0, 0.9, 0, 0.6, 0, 0, 0, 0]),
  new Spell("DYNAMITE", PROJECTILE, [1, 0.9, 0.8, 0.7, 0.6, 0, 0, 0, 0, 0, 0]),
  new Spell("GLITTER_BOMB", PROJECTILE, [0.8, 0.9, 0.8, 0.7, 0.6, 0, 0, 0, 0, 0, 0]),
  new Spell("BUCKSHOT", PROJECTILE, [1, 1, 0.9, 0.9, 0.6, 0, 0, 0, 0, 0, 0]),
  new Spell("FREEZING_GAZE", PROJECTILE, [0, 0, 0.9, 1, 1, 0, 0, 0, 0, 0, 0]),
  new Spell("GLOWING_BOLT", PROJECTILE, [0, 0, 0, 0.8, 0.9, 1, 0, 0, 0, 0, 0.1]),
  new Spell("SPORE_POD", PROJECTILE, [0, 0.7, 0.8, 0.9, 0.8, 0.6, 0, 0, 0, 0, 0]),
  new Spell("GLUE_SHOT", PROJECTILE, [0, 0, 0.7, 0.4, 0.2, 0.5, 0, 0, 0, 0, 0]),
  new Spell("BOMB_HOLY", PROJECTILE, [0, 0, 0.2, 0.2, 0.2, 0.2, 0.2, 0, 0, 0, 0.5]),
  new Spell("BOMB_HOLY_GIGA", PROJECTILE, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("PROPANE_TANK", PROJECTILE, [0, 0, 1, 1, 0.8, 0.8, 0.7, 0, 0, 0, 0]),
  new Spell("BOMB_CART", PROJECTILE, [0, 0, 0.6, 0.6, 0.5, 0.8, 0.6, 0, 0, 0, 0]),
  new Spell("CURSED_ORB", PROJECTILE, [0, 0.3, 0.2, 0.1, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("EXPANDING_ORB", PROJECTILE, [0, 0, 0.5, 0.5, 1, 1, 0.5, 0, 0, 0, 0]),
  new Spell("CRUMBLING_EARTH", PROJECTILE, [0, 0, 0.4, 0.3, 0.5, 0.6, 0.9, 0, 0, 0, 0]),
  new Spell("SUMMON_ROCK", PROJECTILE, [0.8, 0.8, 0.6, 0.6, 0.3, 0.7, 0.7, 0, 0, 0, 0]),
  new Spell("SUMMON_EGG", PROJECTILE, [0.7, 0.8, 0.8, 0.7, 0.6, 0.6, 0.5, 0, 0, 0, 0]),
  new Spell("SUMMON_HOLLOW_EGG", PROJECTILE, [0.6, 0.8, 0.7, 0, 0, 0.8, 0.3, 0, 0, 0, 0]),
  new Spell("TNTBOX", PROJECTILE, [0, 0.8, 0.9, 0.5, 0, 0.4, 0, 0, 0, 0, 0]),
  new Spell("TNTBOX_BIG", PROJECTILE, [0, 0, 0.8, 0, 1, 0.7, 0, 0, 0, 0, 0]),
  new Spell("SWARM_FLY", STATIC_PROJECTILE, [0, 0, 0.3, 0, 0.4, 0.5, 0, 0, 0, 0, 0]),
  new Spell("SWARM_FIREBUG", STATIC_PROJECTILE, [0, 0, 0.2, 0, 0, 0.4, 0.5, 0, 0, 0, 0]),
  new Spell("SWARM_WASP", STATIC_PROJECTILE, [0, 0, 0, 0, 0.2, 0.5, 0.6, 0, 0, 0, 0]),
  new Spell("FRIEND_FLY", STATIC_PROJECTILE, [0, 0, 0, 0, 0.2, 0.6, 0.5, 0, 0, 0, 0]),
  new Spell("ACIDSHOT", PROJECTILE, [0, 1, 1, 0.9, 0.6, 0, 0, 0, 0, 0, 0]),
  new Spell("THUNDERBALL", PROJECTILE, [0, 0, 0.9, 0, 1, 0, 0.7, 0, 0, 0, 0.2]),
  new Spell("FIREBOMB", PROJECTILE, [0, 1, 0.9, 0.7, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("SOILBALL", MATERIAL, [0, 0.8, 0.8, 1, 0, 0.75, 0, 0, 0, 0, 0]),
  new Spell("DEATH_CROSS", PROJECTILE, [0, 1, 0.8, 0.6, 0.5, 0.5, 0.3, 0, 0, 0, 0]),
  new Spell("DEATH_CROSS_BIG", PROJECTILE, [0, 0, 0.4, 0.5, 0.55, 0.3, 0.4, 0, 0, 0, 0.2]),
  new Spell("INFESTATION", PROJECTILE, [0, 0, 0.1, 0.3, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("WALL_HORIZONTAL", STATIC_PROJECTILE, [0.4, 0.4, 0.6, 0, 0.5, 0.2, 0, 0, 0, 0, 0]),
  new Spell("WALL_VERTICAL", STATIC_PROJECTILE, [0.4, 0.4, 0.6, 0, 0.5, 0.2, 0, 0, 0, 0, 0]),
  new Spell("WALL_SQUARE", STATIC_PROJECTILE, [0.3, 0.2, 0.6, 0, 0.5, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("TEMPORARY_WALL", UTILITY, [0.1, 0.1, 0.3, 0, 0.4, 0.2, 0, 0, 0, 0, 0]),
  new Spell("TEMPORARY_PLATFORM", UTILITY, [0.1, 0.1, 0.3, 0, 0.4, 0.2, 0, 0, 0, 0, 0]),
  new Spell("PURPLE_EXPLOSION_FIELD", STATIC_PROJECTILE, [0.7, 1, 0.7, 0, 0.5, 0.5, 0.3, 0, 0, 0, 0]),
  new Spell("DELAYED_SPELL", STATIC_PROJECTILE, [0.8, 0.8, 1, 0, 0.7, 0.5, 0.4, 0, 0, 0, 0]),
  new Spell("LONG_DISTANCE_CAST", UTILITY, [0.6, 0.7, 0.8, 0, 0.6, 0.3, 0.4, 0, 0, 0, 0]),
  new Spell("TELEPORT_CAST", UTILITY, [0, 0.6, 0.6, 0, 0.6, 0.8, 1, 0, 0, 0, 0]),
  new Spell("SUPER_TELEPORT_CAST", UTILITY, [0, 0, 0.2, 0, 0.6, 0.8, 0.8, 0, 0, 0, 0]),
  new Spell("CASTER_CAST", UTILITY, [0, 0, 0.2, 0, 0.2, 0.4, 0.4, 0, 0, 0, 0.2]),
  new Spell("MIST_RADIOACTIVE", PROJECTILE, [0, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("MIST_ALCOHOL", PROJECTILE, [0, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("MIST_SLIME", PROJECTILE, [0, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("MIST_BLOOD", PROJECTILE, [0, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("CIRCLE_FIRE", MATERIAL, [0, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("CIRCLE_ACID", MATERIAL, [0, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("CIRCLE_OIL", MATERIAL, [0, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("CIRCLE_WATER", MATERIAL, [0, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("MATERIAL_WATER", MATERIAL, [0, 0.4, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("MATERIAL_OIL", MATERIAL, [0, 0.4, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("MATERIAL_BLOOD", MATERIAL, [0, 0.4, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("MATERIAL_ACID", MATERIAL, [0, 0, 0.4, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("MATERIAL_CEMENT", MATERIAL, [0, 0, 0.4, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("TELEPORT_PROJECTILE", PROJECTILE, [0.6, 0.6, 0.6, 0, 0.4, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("TELEPORT_PROJECTILE_SHORT", PROJECTILE, [0.6, 0.6, 0.6, 0, 0.4, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("TELEPORT_PROJECTILE_STATIC", PROJECTILE, [0.6, 0.6, 0.6, 0, 0.4, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("SWAPPER_PROJECTILE", PROJECTILE, [0.05, 0.05, 0.1, 0, 0.4, 0.4, 0.1, 0, 0, 0, 0]),
  new Spell("TELEPORT_PROJECTILE_CLOSER", PROJECTILE, [0.4, 0.6, 0.6, 0, 0.7, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("NUKE", PROJECTILE, [0, 0.3, 0, 0, 0, 1, 1, 0, 0, 0, 0.2]),
  new Spell("NUKE_GIGA", PROJECTILE, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("FIREWORK", PROJECTILE, [0, 1, 0.8, 1, 1, 0.5, 0.3, 0, 0, 0, 0]),
  new Spell("SUMMON_WANDGHOST", UTILITY, [0, 0, 0.08, 0, 0.1, 0.3, 0.3, 0, 0, 0, 0.1]),
  new Spell("TOUCH_GOLD", MATERIAL, [0, 0, 0, 0, 0, 0.1, 0.1, 0.1, 0, 0, 0.5]),
  new Spell("TOUCH_WATER", MATERIAL, [0, 0, 0, 0, 0, 0.1, 0.1, 0.1, 0, 0, 0.4]),
  new Spell("TOUCH_OIL", MATERIAL, [0, 0, 0, 0, 0, 0.1, 0.1, 0.1, 0, 0, 0.4]),
  new Spell("TOUCH_ALCOHOL", MATERIAL, [0, 0, 0, 0, 0, 0.1, 0.1, 0.1, 0, 0, 0.4]),
  new Spell("TOUCH_PISS", MATERIAL, [0, 0, 0, 0, 0, 0.035, 0.035, 0.035, 0, 0, 0.1]),
  new Spell("TOUCH_GRASS", MATERIAL, [0, 0, 0, 0, 0, 0.1, 0.1, 0.1, 0, 0, 0.2]),
  new Spell("TOUCH_BLOOD", MATERIAL, [0, 0, 0, 0, 0, 0.1, 0.1, 0.1, 0, 0, 0.5]),
  new Spell("TOUCH_SMOKE", MATERIAL, [0, 0, 0, 0, 0, 0.1, 0.1, 0.1, 0, 0, 0.4]),
  new Spell("DESTRUCTION", STATIC_PROJECTILE, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("MASS_POLYMORPH", STATIC_PROJECTILE, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("BURST_2", DRAW_MANY, [0.8, 0.8, 0.8, 0.8, 0.8, 0.8, 0.8, 0, 0, 0, 0]),
  new Spell("BURST_3", DRAW_MANY, [0, 0.7, 0.7, 0.7, 0.7, 0.7, 0.7, 0, 0, 0, 0]),
  new Spell("BURST_4", DRAW_MANY, [0, 0, 0.4, 0.5, 0.6, 0.6, 0.6, 0, 0, 0, 0]),
  new Spell("BURST_8", DRAW_MANY, [0, 0, 0, 0, 0, 0.1, 0.1, 0, 0, 0, 0.5]),
  new Spell("BURST_X", DRAW_MANY, [0, 0, 0, 0, 0, 0.1, 0.1, 0, 0, 0, 0.5]),
  new Spell("SCATTER_2", DRAW_MANY, [0.8, 0.8, 0.7, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("SCATTER_3", DRAW_MANY, [0.6, 0.7, 0.7, 0.8, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("SCATTER_4", DRAW_MANY, [0, 0.5, 0.6, 0.7, 0.8, 0.8, 0.6, 0, 0, 0, 0]),
  new Spell("I_SHAPE", DRAW_MANY, [0, 0.4, 0.5, 0.3, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("Y_SHAPE", DRAW_MANY, [0.8, 0.5, 0.4, 0.3, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("T_SHAPE", DRAW_MANY, [0, 0.4, 0.5, 0.4, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("W_SHAPE", DRAW_MANY, [0, 0, 0.4, 0.3, 0.5, 0.3, 0.3, 0, 0, 0, 0]),
  new Spell("CIRCLE_SHAPE", DRAW_MANY, [0, 0.1, 0.2, 0.3, 0.3, 0.3, 0.3, 0, 0, 0, 0]),
  new Spell("PENTAGRAM_SHAPE", DRAW_MANY, [0, 0.4, 0.4, 0.3, 0.2, 0.1, 0, 0, 0, 0, 0]),
  new Spell("I_SHOT", UTILITY, [0, 0.1, 0.2, 0.5, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("Y_SHOT", UTILITY, [0, 0.1, 0.2, 0.5, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("T_SHOT", UTILITY, [0, 0, 0.1, 0.2, 0, 0.5, 0, 0, 0, 0, 0]),
  new Spell("W_SHOT", UTILITY, [0, 0, 0.1, 0.2, 0, 0.5, 0.4, 0, 0, 0, 0]),
  new Spell("QUAD_SHOT", UTILITY, [0, 0.1, 0.2, 0, 0.5, 0, 0, 0, 0, 0, 0]),
  new Spell("PENTA_SHOT", UTILITY, [0, 0, 0, 0.1, 0.2, 0.5, 0.5, 0, 0, 0, 0.2]),
  new Spell("HEXA_SHOT", UTILITY, [0, 0, 0, 0.1, 0.2, 0.5, 0.5, 0, 0, 0, 0.2]),
  new Spell("SPREAD_REDUCE", MODIFIER, [0, 0.8, 0.8, 0.8, 0.8, 0.7, 0.6, 0, 0, 0, 0]),
  new Spell("HEAVY_SPREAD", MODIFIER, [0.6, 0.7, 0.8, 0, 0.8, 0.8, 0.6, 0, 0, 0, 0]),
  new Spell("RECHARGE", MODIFIER, [0, 0.8, 0.9, 1, 0.8, 0.9, 1, 0, 0, 0, 0]),
  new Spell("LIFETIME", MODIFIER, [0, 0, 0, 0.5, 0.5, 0.5, 0.75, 0, 0, 0, 0.1]),
  new Spell("LIFETIME_DOWN", MODIFIER, [0, 0, 0, 0.5, 0.5, 0.75, 0.5, 0, 0, 0, 0.1]),
  new Spell("NOLLA", MODIFIER, [0, 0, 0.2, 0, 0.2, 0.5, 0.5, 0, 0, 0, 1]),
  new Spell("SLOW_BUT_STEADY", MODIFIER, [0, 0, 0, 0.1, 0.2, 0.6, 0.6, 0, 0, 0, 0.4]),
  new Spell("EXPLOSION_REMOVE", MODIFIER, [0, 0, 0.2, 0, 0.6, 0.7, 0.2, 0, 0, 0, 0]),
  new Spell("EXPLOSION_TINY", MODIFIER, [0, 0, 0.2, 0, 0.6, 0.7, 0.2, 0, 0, 0, 0]),
  new Spell("LASER_EMITTER_WIDER", MODIFIER, [0, 0, 0.3, 0.3, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("MANA_REDUCE", MODIFIER, [0, 0.7, 0.9, 1, 1, 1, 1, 0, 0, 0, 0]),
  new Spell("BLOOD_MAGIC", UTILITY, [0, 0, 0, 0, 0, 0.3, 0.7, 0, 0, 0, 0.5]),
  new Spell("MONEY_MAGIC", UTILITY, [0, 0, 0, 0.2, 0, 0.8, 0.3, 0, 0, 0, 0.5]),
  new Spell("BLOOD_TO_POWER", UTILITY, [0, 0, 0.2, 0, 0, 0.8, 0.2, 0, 0, 0, 0.5]),
  new Spell("DUPLICATE", OTHER, [0, 0, 0, 0, 0, 0.1, 0.2, 0, 0, 0, 1]),
  new Spell("QUANTUM_SPLIT", MODIFIER, [0, 0, 0.5, 0.6, 0.5, 0.5, 1, 0, 0, 0, 0]),
  new Spell("GRAVITY", MODIFIER, [0, 0, 0.5, 0.4, 0.4, 0.3, 0.3, 0, 0, 0, 0]),
  new Spell("GRAVITY_ANTI", MODIFIER, [0, 0, 0.5, 0.4, 0.4, 0.3, 0.3, 0, 0, 0, 0]),
  new Spell("SINEWAVE", MODIFIER, [0, 0, 0.4, 0, 0.55, 0, 0.4, 0, 0, 0, 0]),
  new Spell("CHAOTIC_ARC", MODIFIER, [0, 0.4, 0, 0.55, 0, 0.4, 0, 0, 0, 0, 0]),
  new Spell("PINGPONG_PATH", MODIFIER, [0, 0.4, 0, 0.5, 0, 0.4, 0, 0, 0, 0, 0]),
  new Spell("AVOIDING_ARC", MODIFIER, [0, 0, 0.5, 0, 0.4, 0, 0.4, 0, 0, 0, 0]),
  new Spell("FLOATING_ARC", MODIFIER, [0, 0.4, 0, 0.4, 0, 0.5, 0, 0, 0, 0, 0]),
  new Spell("FLY_DOWNWARDS", MODIFIER, [0, 0.3, 0, 0.45, 0, 0.3, 0, 0, 0, 0, 0]),
  new Spell("FLY_UPWARDS", MODIFIER, [0, 0, 0.3, 0, 0.45, 0, 0.3, 0, 0, 0, 0]),
  new Spell("HORIZONTAL_ARC", MODIFIER, [0, 0.4, 0, 0.4, 0, 0.4, 0, 0, 0, 0, 0]),
  new Spell("LINE_ARC", MODIFIER, [0, 0.3, 0, 0.4, 0, 0.5, 0, 0, 0, 0, 0]),
  new Spell("ORBIT_SHOT", MODIFIER, [0, 0.2, 0.4, 0.4, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("SPIRALING_SHOT", MODIFIER, [0, 0.2, 0.3, 0.4, 0.5, 0, 0, 0, 0, 0, 0]),
  new Spell("PHASING_ARC", MODIFIER, [0, 0, 0.2, 0.3, 0.6, 0.1, 0, 0, 0, 0, 0]),
  new Spell("TRUE_ORBIT", MODIFIER, [0, 0, 0.2, 0.3, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("BOUNCE", MODIFIER, [0, 0, 1, 1, 0.4, 0, 0.2, 0, 0, 0, 0]),
  new Spell("REMOVE_BOUNCE", MODIFIER, [0, 0, 0.2, 0.2, 1, 1, 0, 0, 0, 0, 0]),
  new Spell("HOMING", MODIFIER, [0, 0.1, 0.4, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("ANTI_HOMING", MODIFIER, [0, 0.05, 0.3, 0.3, 0.1, 0.1, 0.01, 0, 0, 0, 0]),
  new Spell("HOMING_WAND", MODIFIER, [0, 0.00001, 0.08, 0, 0.08, 0.25, 0.25, 0, 0, 0, 0.2]),
  new Spell("HOMING_SHORT", MODIFIER, [0, 0.4, 0.8, 1, 0.4, 0.3, 0.1, 0, 0, 0, 0]),
  new Spell("HOMING_ROTATE", MODIFIER, [0, 0, 0.2, 0.4, 0.6, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("HOMING_SHOOTER", MODIFIER, [0, 0, 0.2, 0.3, 0.2, 0, 0.2, 0, 0, 0, 0]),
  new Spell("AUTOAIM", MODIFIER, [0, 0, 0.4, 0.4, 0.4, 0.4, 0.4, 0, 0, 0, 0]),
  new Spell("HOMING_ACCELERATING", MODIFIER, [0, 0.1, 0.3, 0.3, 0.5, 0, 0, 0, 0, 0, 0]),
  new Spell("HOMING_CURSOR", MODIFIER, [0, 0, 0.7, 0.7, 0.4, 0.4, 1, 0, 0, 0, 0]),
  new Spell("HOMING_AREA", MODIFIER, [0, 0, 0.2, 0.4, 0.6, 0.7, 0.4, 0, 0, 0, 0]),
  new Spell("PIERCING_SHOT", MODIFIER, [0, 0, 0.4, 0.5, 0.6, 0.6, 0.4, 0, 0, 0, 0]),
  new Spell("CLIPPING_SHOT", MODIFIER, [0, 0, 0.2, 0.3, 0.6, 0.4, 0.6, 0, 0, 0, 0]),
  new Spell("DAMAGE", MODIFIER, [0, 0.6, 0.6, 0.8, 0.6, 0.6, 0, 0, 0, 0, 0]),
  new Spell("DAMAGE_RANDOM", MODIFIER, [0, 0, 0, 0.7, 0.6, 0.6, 0, 0, 0, 0, 0]),
  new Spell("BLOODLUST", MODIFIER, [0, 0.2, 0, 0.3, 0.6, 0.7, 0.3, 0, 0, 0, 0]),
  new Spell("DAMAGE_FOREVER", MODIFIER, [0, 0, 0.2, 0.3, 0.6, 0.5, 0.2, 0, 0, 0, 0.2]),
  new Spell("CRITICAL_HIT", MODIFIER, [0, 0.5, 0.6, 0.6, 0.7, 0.6, 0, 0, 0, 0, 0]),
  new Spell("AREA_DAMAGE", MODIFIER, [0, 0, 0.4, 0.5, 0.5, 0.5, 0.6, 0, 0, 0, 0]),
  new Spell("SPELLS_TO_POWER", MODIFIER, [0, 0, 0.3, 0.3, 0.5, 0.5, 0.5, 0, 0, 0, 0.1]),
  new Spell("ESSENCE_TO_POWER", MODIFIER, [0, 0.2, 0.5, 0.5, 0, 0, 0.5, 0, 0, 0, 0.1]),
  new Spell("ZERO_DAMAGE", MODIFIER, [0, 0, 0, 0.3, 0.3, 0.6, 0, 0, 0, 0, 0.3]),
  new Spell("HEAVY_SHOT", MODIFIER, [0, 0, 0.4, 0.4, 0.5, 0, 0, 0, 0, 0, 0]),
  new Spell("LIGHT_SHOT", MODIFIER, [0, 0, 0.3, 0.5, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("KNOCKBACK", MODIFIER, [0, 0, 0, 0.7, 0, 0.6, 0, 0, 0, 0, 0]),
  new Spell("RECOIL", MODIFIER, [0, 0, 0.6, 0, 0.7, 0, 0, 0, 0, 0, 0]),
  new Spell("RECOIL_DAMPER", MODIFIER, [0, 0, 0, 0.6, 0, 0, 0.7, 0, 0, 0, 0]),
  new Spell("SPEED", MODIFIER, [0, 1, 0.5, 0.5, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("ACCELERATING_SHOT", MODIFIER, [0, 0, 0.5, 0.4, 1, 0, 0, 0, 0, 0, 0]),
  new Spell("DECELERATING_SHOT", MODIFIER, [0, 0, 0.4, 0.1, 0.7, 0, 0, 0, 0, 0, 0]),
  new Spell("EXPLOSIVE_PROJECTILE", MODIFIER, [0, 0, 1, 1, 0.8, 0, 0, 0, 0, 0, 0]),
  new Spell("CLUSTERMOD", MODIFIER, [0, 0.5, 1, 0.6, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("WATER_TO_POISON", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("BLOOD_TO_ACID", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("LAVA_TO_BLOOD", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("LIQUID_TO_EXPLOSION", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("TOXIC_TO_ACID", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("STATIC_TO_SAND", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0.2]),
  new Spell("TRANSMUTATION", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0.3, 0.3, 0, 0, 0, 0.2]),
  new Spell("RANDOM_EXPLOSION", MODIFIER, [0, 0, 0, 0.3, 0, 0.6, 1, 0, 0, 0, 0]),
  new Spell("NECROMANCY", MODIFIER, [0, 0, 0.4, 0.6, 0.6, 0.3, 0, 0, 0, 0, 0]),
  new Spell("LIGHT", MODIFIER, [1, 0.8, 0.6, 0.4, 0.2, 0, 0, 0, 0, 0, 0]),
  new Spell("EXPLOSION", STATIC_PROJECTILE, [0.5, 0, 1, 0, 1, 0.7, 0, 0, 0, 0, 0]),
  new Spell("EXPLOSION_LIGHT", STATIC_PROJECTILE, [0, 0, 0.5, 1, 0, 0.7, 0.5, 0, 0, 0, 0]),
  new Spell("FIRE_BLAST", STATIC_PROJECTILE, [0.5, 0.7, 0, 0.6, 0, 0.4, 0, 0, 0, 0, 0]),
  new Spell("POISON_BLAST", STATIC_PROJECTILE, [0, 0.5, 0.8, 0, 0.4, 0, 0.3, 0, 0, 0, 0]),
  new Spell("ALCOHOL_BLAST", STATIC_PROJECTILE, [0, 0.5, 0.6, 0, 0.65, 0, 0.3, 0, 0, 0, 0]),
  new Spell("THUNDER_BLAST", STATIC_PROJECTILE, [0, 0.5, 0, 0.6, 0, 0.7, 0.5, 0, 0, 0, 0.1]),
  new Spell("BERSERK_FIELD", STATIC_PROJECTILE, [0, 0, 0.3, 0.6, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("POLYMORPH_FIELD", STATIC_PROJECTILE, [0.3, 0.3, 0.3, 0.8, 0.8, 0.3, 0.3, 0, 0, 0, 0]),
  new Spell("CHAOS_POLYMORPH_FIELD", STATIC_PROJECTILE, [0, 0.3, 0.3, 0.5, 0.6, 0.3, 0.3, 0, 0, 0, 0]),
  new Spell("ELECTROCUTION_FIELD", STATIC_PROJECTILE, [0, 0.3, 0, 0.6, 0, 0.8, 0.3, 0, 0, 0, 0]),
  new Spell("FREEZE_FIELD", STATIC_PROJECTILE, [0.3, 0, 0.6, 0, 0.7, 0.3, 0, 0, 0, 0, 0]),
  new Spell("REGENERATION_FIELD", STATIC_PROJECTILE, [0, 0.3, 0.3, 0.4, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("TELEPORTATION_FIELD", STATIC_PROJECTILE, [0.3, 0.6, 0.3, 0.3, 0.6, 0.3, 0, 0, 0, 0, 0]),
  new Spell("LEVITATION_FIELD", STATIC_PROJECTILE, [0, 0.3, 0.6, 0.6, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("SHIELD_FIELD", STATIC_PROJECTILE, [0, 0, 0.3, 0.3, 0.4, 0.5, 0.3, 0, 0, 0, 0]),
  new Spell("PROJECTILE_TRANSMUTATION_FIELD", STATIC_PROJECTILE, [0, 0, 0.3, 0.4, 0.4, 0.3, 0.3, 0, 0, 0, 0]),
  new Spell("PROJECTILE_THUNDER_FIELD", STATIC_PROJECTILE, [0, 0, 0, 0.3, 0.3, 0.5, 0.3, 0, 0, 0, 0]),
  new Spell("PROJECTILE_GRAVITY_FIELD", STATIC_PROJECTILE, [0, 0, 0.6, 0, 0, 0.3, 0.3, 0, 0, 0, 0]),
  new Spell("VACUUM_POWDER", STATIC_PROJECTILE, [0, 0, 0.3, 0.7, 0, 0.3, 0.4, 0, 0, 0, 0]),
  new Spell("VACUUM_LIQUID", STATIC_PROJECTILE, [0, 0, 0.3, 0, 0.7, 0.4, 0.3, 0, 0, 0, 0]),
  new Spell("VACUUM_ENTITIES", STATIC_PROJECTILE, [0, 0, 0.3, 0.7, 0, 0.3, 0.4, 0, 0, 0, 0]),
  new Spell("SEA_LAVA", MATERIAL, [0.2, 0, 0, 0, 0.2, 0.5, 0.6, 0, 0, 0, 0]),
  new Spell("SEA_ALCOHOL", MATERIAL, [0.3, 0, 0, 0, 0.5, 0.6, 0.3, 0, 0, 0, 0]),
  new Spell("SEA_OIL", MATERIAL, [0.3, 0, 0, 0, 0.5, 0.6, 0.3, 0, 0, 0, 0]),
  new Spell("SEA_WATER", MATERIAL, [0.5, 0, 0, 0, 0.4, 0.3, 0.2, 0, 0, 0, 0]),
  new Spell("SEA_SWAMP", MATERIAL, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("SEA_ACID", MATERIAL, [0.2, 0, 0, 0, 0.2, 0.4, 0.5, 0, 0, 0, 0]),
  new Spell("SEA_ACID_GAS", MATERIAL, [0.3, 0, 0, 0, 0.4, 0.4, 0.3, 0, 0, 0, 0]),
  new Spell("SEA_MIMIC", MATERIAL, [0.05, 0, 0, 0, 0.05, 0.1, 0.1, 0, 0, 0, 0.2]),
  new Spell("CLOUD_WATER", STATIC_PROJECTILE, [0.2, 0.3, 0.4, 0.4, 0.3, 0.2, 0, 0, 0, 0, 0]),
  new Spell("CLOUD_OIL", STATIC_PROJECTILE, [0.2, 0.3, 0.4, 0.4, 0.3, 0.2, 0, 0, 0, 0, 0]),
  new Spell("CLOUD_BLOOD", STATIC_PROJECTILE, [0.2, 0.3, 0.3, 0.4, 0.3, 0.2, 0, 0, 0, 0, 0]),
  new Spell("CLOUD_ACID", STATIC_PROJECTILE, [0.2, 0.2, 0.4, 0.2, 0.2, 0.5, 0, 0, 0, 0, 0]),
  new Spell("CLOUD_THUNDER", STATIC_PROJECTILE, [0.3, 0.3, 0.2, 0.3, 0.4, 0.5, 0, 0, 0, 0, 0]),
  new Spell("ELECTRIC_CHARGE", MODIFIER, [0, 1, 1, 0, 0.8, 0.7, 0, 0, 0, 0, 0]),
  new Spell("MATTER_EATER", MODIFIER, [0, 0.1, 0.9, 0, 0.1, 0.2, 0, 0, 0, 0, 0.2]),
  new Spell("FREEZE", MODIFIER, [0, 1, 0, 1, 0.9, 0.8, 0, 0, 0, 0, 0]),
  new Spell("HITFX_BURNING_CRITICAL_HIT", MODIFIER, [0, 0.2, 0, 0.4, 0.2, 0.2, 0, 0, 0, 0, 0]),
  new Spell("HITFX_CRITICAL_WATER", MODIFIER, [0, 0.2, 0, 0.2, 0.4, 0.2, 0, 0, 0, 0, 0]),
  new Spell("HITFX_CRITICAL_OIL", MODIFIER, [0, 0.2, 0, 0.4, 0.2, 0.2, 0, 0, 0, 0, 0]),
  new Spell("HITFX_CRITICAL_BLOOD", MODIFIER, [0, 0.2, 0, 0.2, 0.2, 0.4, 0, 0, 0, 0, 0]),
  new Spell("HITFX_TOXIC_CHARM", MODIFIER, [0, 0.2, 0, 0.2, 0.3, 0.2, 0, 0, 0, 0, 0]),
  new Spell("HITFX_EXPLOSION_SLIME", MODIFIER, [0, 0.2, 0, 0.3, 0.2, 0.2, 0, 0, 0, 0, 0]),
  new Spell("HITFX_EXPLOSION_SLIME_GIGA", MODIFIER, [0, 0.1, 0, 0.1, 0.3, 0.1, 0, 0, 0, 0, 0]),
  new Spell("HITFX_EXPLOSION_ALCOHOL", MODIFIER, [0, 0.3, 0, 0.2, 0.2, 0.2, 0, 0, 0, 0, 0]),
  new Spell("HITFX_EXPLOSION_ALCOHOL_GIGA", MODIFIER, [0, 0.1, 0, 0.1, 0.1, 0.3, 0, 0, 0, 0, 0]),
  new Spell("HITFX_PETRIFY", MODIFIER, [0, 0, 0.2, 0.3, 0, 0.2, 0.3, 0, 0, 0, 0]),
  new Spell("ROCKET_DOWNWARDS", MODIFIER, [0, 0.2, 0.5, 0.7, 0.7, 0, 0, 0, 0, 0, 0]),
  new Spell("ROCKET_OCTAGON", MODIFIER, [0, 0, 0.5, 0.6, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("FIZZLE", MODIFIER, [0, 0, 0, 0.4, 0.3, 0.1, 0, 0, 0, 0, 0]),
  new Spell("BOUNCE_EXPLOSION", MODIFIER, [0, 0, 0.2, 0.6, 0.8, 0.8, 0, 0, 0, 0, 0]),
  new Spell("BOUNCE_SPARK", MODIFIER, [0, 0.2, 0.6, 0.6, 0.6, 0, 0, 0, 0, 0, 0]),
  new Spell("BOUNCE_LASER", MODIFIER, [0, 0, 0, 0.4, 0.8, 0.4, 0, 0, 0, 0, 0]),
  new Spell("BOUNCE_LASER_EMITTER", MODIFIER, [0, 0, 0, 0.4, 0.8, 0.4, 0, 0, 0, 0, 0]),
  new Spell("BOUNCE_LARPA", MODIFIER, [0, 0, 0, 0, 0.4, 0.6, 0.4, 0, 0, 0, 0]),
  new Spell("BOUNCE_SMALL_EXPLOSION", MODIFIER, [0.5, 0.3, 0.3, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("BOUNCE_LIGHTNING", MODIFIER, [0, 0.1, 0, 0.3, 0, 0.6, 0, 0, 0, 0, 0]),
  new Spell("BOUNCE_HOLE", MODIFIER, [0, 0, 0.1, 0, 0.4, 0, 0.4, 0, 0, 0, 0.1]),
  new Spell("FIREBALL_RAY", MODIFIER, [0, 0.6, 0.6, 0, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("LIGHTNING_RAY", MODIFIER, [0, 0, 0.2, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("TENTACLE_RAY", MODIFIER, [0, 0.1, 0, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("LASER_EMITTER_RAY", MODIFIER, [0, 0, 0.1, 0.4, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("FIREBALL_RAY_LINE", MODIFIER, [0, 0, 0.6, 0.4, 0.4, 0.4, 1, 0, 0, 0, 0]),
  new Spell("FIREBALL_RAY_ENEMY", MODIFIER, [0, 0.5, 0.6, 0, 0.4, 0.3, 0, 0, 0, 0, 0]),
  new Spell("LIGHTNING_RAY_ENEMY", MODIFIER, [0, 0, 0.2, 0.4, 0.4, 0.5, 0, 0, 0, 0, 0]),
  new Spell("TENTACLE_RAY_ENEMY", MODIFIER, [0, 0, 0.1, 0.4, 0.5, 0.4, 0, 0, 0, 0, 0]),
  new Spell("GRAVITY_FIELD_ENEMY", MODIFIER, [0, 0.5, 0.6, 0, 0.4, 0.4, 0, 0, 0, 0, 0]),
  new Spell("CURSE", MODIFIER, [0, 0, 0.6, 0.7, 0, 0.4, 0, 0, 0, 0, 0.1]),
  new Spell("CURSE_WITHER_PROJECTILE", MODIFIER, [0, 0, 0, 0.2, 0.4, 0.7, 0.7, 0, 0, 0, 0.1]),
  new Spell("CURSE_WITHER_EXPLOSION", MODIFIER, [0, 0, 0.2, 0.4, 0.7, 0.7, 0, 0, 0, 0, 0.1]),
  new Spell("CURSE_WITHER_MELEE", MODIFIER, [0, 0, 0, 0.2, 0.4, 0.7, 0.7, 0, 0, 0, 0.1]),
  new Spell("CURSE_WITHER_ELECTRICITY", MODIFIER, [0, 0.2, 0, 0, 0.4, 0.7, 0.7, 0, 0, 0, 0.1]),
  new Spell("ORBIT_DISCS", MODIFIER, [0, 0.3, 0.65, 0, 0.4, 0.3, 0, 0, 0, 0, 0]),
  new Spell("ORBIT_FIREBALLS", MODIFIER, [0.2, 0.3, 0.7, 0, 0.4, 0.2, 0, 0, 0, 0, 0]),
  new Spell("ORBIT_NUKES", MODIFIER, [0, 0, 0.1, 0, 0.2, 0.1, 0.2, 0, 0, 0, 1]),
  new Spell("ORBIT_LASERS", MODIFIER, [0, 0.2, 0.7, 0, 0.4, 0.3, 0, 0, 0, 0, 0.2]),
  new Spell("ORBIT_LARPA", MODIFIER, [0, 0, 0, 0.2, 0.2, 0, 0.8, 0, 0, 0, 0.2]),
  new Spell("CHAIN_SHOT", MODIFIER, [0, 0, 0.4, 0, 0.6, 0.8, 0, 0, 0, 0, 0]),
  new Spell("ARC_ELECTRIC", MODIFIER, [0, 0, 0.4, 0.4, 0.4, 0.4, 0.8, 0, 0, 0, 0]),
  new Spell("ARC_FIRE", MODIFIER, [0, 0.4, 0.2, 0.2, 0.5, 0.2, 0, 0, 0, 0, 0]),
  new Spell("ARC_GUNPOWDER", MODIFIER, [0, 0.4, 0.4, 0.2, 0.4, 0.2, 0, 0, 0, 0, 0]),
  new Spell("ARC_POISON", MODIFIER, [0, 0.4, 0.2, 0.4, 0.2, 0.4, 0, 0, 0, 0, 0]),
  new Spell("CRUMBLING_EARTH_PROJECTILE", MODIFIER, [0, 0.2, 0.3, 0.4, 0.4, 0.3, 0, 0, 0, 0, 0]),
  new Spell("X_RAY", UTILITY, [0.8, 1, 1, 0.7, 0.5, 0.3, 0.2, 0, 0, 0, 0]),
  new Spell("UNSTABLE_GUNPOWDER", MODIFIER, [0, 0, 0.3, 0.4, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("ACID_TRAIL", MODIFIER, [0, 0.3, 0.2, 0.3, 0.3, 0.4, 0, 0, 0, 0, 0]),
  new Spell("POISON_TRAIL", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("OIL_TRAIL", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("WATER_TRAIL", MODIFIER, [0, 0.3, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("GUNPOWDER_TRAIL", MODIFIER, [0, 0, 0.3, 0.3, 0.3, 0, 0, 0, 0, 0, 0]),
  new Spell("FIRE_TRAIL", MODIFIER, [0.4, 0.5, 0.3, 0.3, 0.2, 0, 0, 0, 0, 0, 0]),
  new Spell("BURN_TRAIL", MODIFIER, [0.4, 0.3, 0.3, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("TORCH", PASSIVE, [1, 0.6, 0.5, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("TORCH_ELECTRIC", PASSIVE, [0.8, 0.6, 0.4, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("ENERGY_SHIELD", PASSIVE, [0, 0.05, 0.4, 0.8, 0.4, 0.4, 0.6, 0, 0, 0, 0]),
  new Spell("ENERGY_SHIELD_SECTOR", PASSIVE, [0.1, 0.5, 0.6, 0.8, 0.5, 0.4, 0, 0, 0, 0, 0]),
  new Spell("ENERGY_SHIELD_SHOT", MODIFIER, [0, 0, 0.3, 0.3, 0.5, 0.4, 0.3, 0, 0, 0, 0]),
  new Spell("TINY_GHOST", PASSIVE, [0, 0.1, 0.5, 1, 0.8, 0.7, 0.5, 0, 0, 0, 0]),
  new Spell("OCARINA_A", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("OCARINA_B", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("OCARINA_C", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("OCARINA_D", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("OCARINA_E", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("OCARINA_F", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("OCARINA_GSHARP", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("OCARINA_A2", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("KANTELE_A", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("KANTELE_D", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("KANTELE_DIS", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("KANTELE_E", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("KANTELE_G", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("RANDOM_SPELL", OTHER, [0, 0, 0, 0.2, 0.3, 0.2, 0.1, 0, 0, 0, 0.5]),
  new Spell("RANDOM_PROJECTILE", PROJECTILE, [0, 0, 0.2, 0, 0.4, 0.1, 0.2, 0, 0, 0, 0.5]),
  new Spell("RANDOM_MODIFIER", MODIFIER, [0, 0, 0, 0, 0.3, 0.2, 0.1, 0, 0, 0, 0.5]),
  new Spell("RANDOM_STATIC_PROJECTILE", STATIC_PROJECTILE, [0, 0, 0, 0.2, 0, 0.1, 0.2, 0, 0, 0, 0.5]),
  new Spell("DRAW_RANDOM", OTHER, [0, 0, 0.3, 0.2, 0.2, 0.1, 0.1, 0, 0, 0, 1]),
  new Spell("DRAW_RANDOM_X3", OTHER, [0, 0, 0, 0.1, 0.3, 0.1, 0.1, 0, 0, 0, 1]),
  new Spell("DRAW_3_RANDOM", OTHER, [0, 0, 0.1, 0.2, 0, 0.1, 0.1, 0, 0, 0, 1]),
  new Spell("ALL_NUKES", UTILITY, [0, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 1]),
  new Spell("ALL_DISCS", UTILITY, [0.1, 0, 0, 0, 0, 0, 0.05, 0, 0, 0, 1]),
  new Spell("ALL_ROCKETS", UTILITY, [0, 0.1, 0, 0, 0, 0, 0.05, 0, 0, 0, 1]),
  new Spell("ALL_DEATHCROSSES", UTILITY, [0, 0, 0.1, 0, 0, 0, 0.05, 0, 0, 0, 1]),
  new Spell("ALL_BLACKHOLES", UTILITY, [0, 0, 0, 0.1, 0, 0, 0.05, 0, 0, 0, 1]),
  new Spell("ALL_ACID", UTILITY, [0, 0, 0, 0, 0.1, 0, 0.05, 0, 0, 0, 1]),
  new Spell("ALL_SPELLS", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("SUMMON_PORTAL", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("ADD_TRIGGER", OTHER, [0, 0, 0, 0.3, 0.6, 0.6, 0, 0, 0, 0, 1]),
  new Spell("ADD_TIMER", OTHER, [0, 0, 0, 0.3, 0.6, 0.6, 0, 0, 0, 0, 1]),
  new Spell("ADD_DEATH_TRIGGER", OTHER, [0, 0, 0, 0.3, 0.6, 0.6, 0, 0, 0, 0, 1]),
  new Spell("LARPA_CHAOS", MODIFIER, [0, 0, 0.1, 0.2, 0.3, 0.4, 0, 0, 0, 0, 0.2]),
  new Spell("LARPA_DOWNWARDS", MODIFIER, [0, 0, 0.1, 0.3, 0.4, 0.2, 0, 0, 0, 0, 0.2]),
  new Spell("LARPA_UPWARDS", MODIFIER, [0, 0, 0.1, 0.1, 0.2, 0.4, 0, 0, 0, 0, 0.2]),
  new Spell("LARPA_CHAOS_2", MODIFIER, [0, 0, 0, 0.1, 0, 0.4, 0, 0, 0, 0, 0.1]),
  new Spell("LARPA_DEATH", MODIFIER, [0, 0, 0.1, 0.1, 0.3, 0.4, 0, 0, 0, 0, 0.2]),
  new Spell("ALPHA", OTHER, [0, 0, 0, 0, 0, 0.1, 0.2, 0, 0, 0, 1]),
  new Spell("GAMMA", OTHER, [0, 0, 0, 0, 0, 0.1, 0.2, 0, 0, 0, 1]),
  new Spell("TAU", OTHER, [0, 0, 0, 0, 0, 0.1, 0.2, 0, 0, 0, 1]),
  new Spell("OMEGA", OTHER, [0, 0, 0, 0, 0, 0.1, 0.1, 0, 0, 0, 1]),
  new Spell("MU", OTHER, [0, 0, 0, 0, 0, 0.1, 0.2, 0, 0, 0, 1]),
  new Spell("PHI", OTHER, [0, 0, 0, 0, 0, 0.1, 0.2, 0, 0, 0, 1]),
  new Spell("SIGMA", OTHER, [0, 0, 0, 0, 0.1, 0.2, 0, 0, 0, 0, 1]),
  new Spell("ZETA", OTHER, [0, 0, 0.2, 0, 0, 0.4, 0, 0, 0, 0, 0.5]),
  new Spell("DIVIDE_2", OTHER, [0, 0, 0, 0.2, 0, 0.3, 0.2, 0, 0, 0, 1]),
  new Spell("DIVIDE_3", OTHER, [0, 0, 0, 0, 0.1, 0.1, 0.2, 0, 0, 0, 1]),
  new Spell("DIVIDE_4", OTHER, [0, 0, 0, 0, 0, 0.1, 0.1, 0, 0, 0, 1]),
  new Spell("DIVIDE_10", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("METEOR_RAIN", STATIC_PROJECTILE, [0, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 1]),
  new Spell("WORM_RAIN", STATIC_PROJECTILE, [0, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 1]),
  new Spell("RESET", UTILITY, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("IF_ENEMY", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("IF_PROJECTILE", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("IF_HP", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("IF_HALF", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("IF_END", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("IF_ELSE", OTHER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1]),
  new Spell("COLOUR_RED", MODIFIER, [0, 0.2, 0.2, 0.4, 0.2, 0.2, 0.2, 0, 0, 0, 0]),
  new Spell("COLOUR_ORANGE", MODIFIER, [0, 0, 0.1, 0.1, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("COLOUR_GREEN", MODIFIER, [0, 0, 0.4, 0.1, 0.1, 0, 0, 0, 0, 0, 0]),
  new Spell("COLOUR_YELLOW", MODIFIER, [0, 0, 0.1, 0.4, 0.1, 0, 0, 0, 0, 0, 0]),
  new Spell("COLOUR_PURPLE", MODIFIER, [0, 0, 0.1, 0.1, 0.4, 0, 0, 0, 0, 0, 0]),
  new Spell("COLOUR_BLUE", MODIFIER, [0, 0, 0.4, 0.1, 0.1, 0, 0, 0, 0, 0, 0]),
  new Spell("COLOUR_RAINBOW", MODIFIER, [0, 0, 0.1, 0.1, 0.1, 0, 0, 0, 0, 0, 0.2]),
  new Spell("COLOUR_INVIS", MODIFIER, [0, 0, 0.1, 0.1, 0.1, 0, 0, 0, 0, 0, 0.1]),
  new Spell("RAINBOW_TRAIL", MODIFIER, [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
  new Spell("CESSATION", OTHER, [0, 0, 0, 0, 0, 0.1, 0.2, 0, 0, 0, 1])
];

// Precompute spawnability constraints
for (const spell of ALL_SPELLS) {
    let totalProb = 0;
    for (let i = 0; i < spell.spawn_probabilities.length; i++) {
        totalProb += spell.spawn_probabilities[i];
    }
    spell.can_spawn = spell.name === 'SEA_SWAMP' || spell.name === 'SUMMON_PORTAL' || totalProb > 0;
    spell.can_spawn_in_boxes = (spell.type === MODIFIER || spell.type === UTILITY) && (spell.name === 'SEA_SWAMP' || spell.name === 'SUMMON_PORTAL' || totalProb > 0);
}

let spellTierData = {};
for (let i = 0; i <= 10; i++) {
    spellTierData[i] = {
        spells: [],
        probs: [],
        totalProb: 0
    };
}
for (const spell of ALL_SPELLS) {
    for (let tier = 0; tier <= 10; tier++) {
        const prob = spell.spawn_probabilities[tier];
        if (prob > 0) {
            spellTierData[tier].spells.push(spell.name);
            spellTierData[tier].probs.push(prob);
            spellTierData[tier].totalProb += prob;
        }
    }
}
//console.log("Done precomputing spell tier data.");

export const T10_SPELLS = ALL_SPELLS.filter(spell => spell.spawn_probabilities[10] > 0).map(spell => spell.name);